export default {
  methods: {
		formatData (vm, rows) {
			for (let row of rows) {
				Object.entries(row).forEach(([key, value]) => {
				let searchKey = key;
				let column = vm.headers.find ( h => h.field==searchKey);
				if (!column) {
					let searchKey = this.adjustFormatterSearchKey(key);
					column = vm.headers.find ( h => h.field==searchKey);
				}
				if (column && column.formatter) {
					row[key] = vm[column.formatter](value, column);
				}
			});
		}
		return rows;
	},
  adjustFormatterSearchKey(key) {
		const regex = /((composite|avatar)[1-9])(_title|_subtitle)/;
		const match = key.match(regex);
		if (match && match.length > 1) {
			return match[1];
		}
		return key;
	},
	addCustomData (vm, rows) {
		for (let header of vm.headers) {
			if (header.customValue) {
				for (let row of rows) {
					row[header.field] = header.customValue(row);
				}
			}
		}
		return rows;
	},
	formatDecimalNumber(value) {
		if (value && typeof value === 'number') {
			return (Math.round(value * 100) / 100).toFixed(2).toLocaleString();
		}
		return value;
	},
		formatBoolean (value) {
			return (typeof value === 'undefined' ) ? '' : 
				(value ? this.$t('common.yes').toUpperCase() : this.$t('common.no').toUpperCase());
		},
		formatDate (value) {
			//return this.formatLongDate(value);
			//return !value ? '' : new Date(value.split("[")[0]).toLocaleDateString();
			return !value ? '' : new Date(value.split("[")[0]).toLocaleDateString([this.$i18n.locale, "en"], { year: "numeric", month: "2-digit", day: "2-digit" });
		},
		formatLongDate (value) {
			return !value ? '' : new Date(value.split("[")[0]).toLocaleDateString([this.$i18n.locale, "en"], { weekday: "long", year: "numeric", month: "long", day: "2-digit" });
		},
		formatDateTime (value) {
			//return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
			return !value ? '' : new Date(value.split("[")[0]).toLocaleDateString([this.$i18n.locale, "en"], { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false  });
		},
		/*formatLongDateTime (value) {
			//return this.formatLongDateTime(value, true);
			//return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
			return !value ? '' : new Date(value).toLocaleDateString([this.$i18n.locale, "en"], { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });
		},*/
		formatSimpleDate (value) {
			return this.formatDate(new Date(value.year, value.month-1, value.day, 0, 0, 0, 0));
			//return this.formatLongDate(new Date(value.year, value.month-1, value.day, 0, 0, 0, 0).getTime());
			//return !value ? '' : new Date(value.year, value.month-1, value.day, 0, 0, 0, 0).toLocaleDateString();
		},
		formatTime (value) {
			if (!value) return '';

			let avalue = Math.abs(value);

			let sign = avalue==value ? "":"-";
			
			let hours = Math.floor(avalue);
			let mins = Math.floor((avalue - hours) * 60);
			let secs = Math.floor((avalue - hours - mins/60) * 3660);
			
			return sign + hours + ":" + `${mins}`.padStart(2, '0') + ":" + `${secs}`.padStart(2, '0');
		},
		formatChoice (value, field) {
			if (!value && value!==0 && value!==false) return '';

			if (!field.choices) return value;

			let choice = field.choices.find( h => h.key==value);

			if (!choice) return value;

			return this.st(choice.value);
		},
		formatStatus (value) {
			if (!value && value!==0 && value!==false) return '';

			let color = '';

			// (0) creado, (1) enviado, (2) en progreso, (3) completado, (4) cancelado, (5) archivado
			switch (value) {
				case 0: color = 'purple'; break;
				case 1: color = 'blue'; break;
				case 2: color = 'orange'; break;
				case 3: color = 'green'; break;
				case 4: color = 'red'; break;
				case 5: color = 'grey'; break;
			}

			return {
				color: color,
				text: this.$t(`dashboards.fields.status-${value}`)
			};
		},
	},
}